import React from 'react';
const facts = [{
  value: '77',
  label: 'Ready-to-run sessions'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '3',
  label: 'Levels in every drill'
}, {
  value: '20',
  label: 'Printable worksheets'
}];
export function SocialProofBar() {
  return <section className="w-full bg-light" data-id="element-300" data-mp="29s2zm88o19b7">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-301" data-mp="25tvktixrii2n">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-line bg-line shadow-card sm:grid-cols-4" data-id="element-302" data-mp="32j4jgmnazt12">
          {facts.map(fact => <div key={fact.label} className="bg-white px-4 py-5 text-center" data-id="element-303" data-mp="2xkta0d0x7kjd">
              <div className="font-display text-3xl font-extrabold sm:text-4xl leading-none text-court" data-id="element-304" data-mp="2th3nru7pxf1i">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-305" data-mp="1i39kyexww43q">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}